// extracted by mini-css-extract-plugin
export default {"container":"SessionAbout_container__RJamz","heading":"SessionAbout_heading__P2Cys"};